import { useCallback } from 'react';

// eslint-disable-next-line no-restricted-imports
import {
  OnboardingLegalClientDocument,
  useLegalClientDeleteLegalHeadMutation,
} from 'api/generated/graphql';
import { useError } from 'api/helpers';

export const useLegalClientDeleteLegalHead = () => {
  const [handle, { loading, error: apolloError }] =
    useLegalClientDeleteLegalHeadMutation({
      refetchQueries: [OnboardingLegalClientDocument],
      awaitRefetchQueries: true,
    });

  const error = useError(apolloError);

  return {
    loading,
    error,
    deleteLegalHead: useCallback(
      async (id: string, legalHeadId: string) => {
        await handle({
          variables: {
            id,
            legalHeadId,
          },
        });
      },
      [handle]
    ),
  };
};
